<template>
  <div class="ImageParent">
    <div class="Link">
      <picture>
        <source type="image/webp" :srcset="require(`@/` + data.sources.webp)" />
        <img
          :alt="data.alt"
          class="Image"
          :src="require('@/' + data.sources.png)"
        />
      </picture>
    </div>
  </div>
</template>

<script>
import { entity } from '@/../region.json';

export default {
  props: ['data', 'vStyle'],
  data() {
    return {
      entity,
    };
  },
};
</script>
<style scoped>
.ImageParent {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Link {
  max-height: 100%;
  height: 100%;
}

.Image {
  max-height: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}
</style>
